export const CASH = 'CASH';
export const DEBIT = 'DEBIT';
export const BANK_TRANSFER = 'BANK_TRANSFER';
export const MP_TRANSFER = 'MP_TRANSFER';
export const PAYMENT_METHODS = [CASH, DEBIT,BANK_TRANSFER,MP_TRANSFER]
